import * as z from "zod/v4";

export const reasonBreakdownSchema = z.object({
  reason: z.string(),
  count: z.coerce.number(),
  totalAmount: z.coerce.number(),
});

export type ReasonBreakdown = z.infer<typeof reasonBreakdownSchema>;

export const dashboardStatsSchema = z.object({
  totalCount: z.coerce.number(),
  needsResponseCount: z.coerce.number(),
  wonCount: z.coerce.number(),
  lostCount: z.coerce.number(),
  evidenceSubmittedCount: z.coerce.number(),
  underReviewCount: z.coerce.number(),
  totalAmount: z.coerce.number(),
  wonAmount: z.coerce.number(),
  finalizedAmount: z.coerce.number(),
  currency: z.string(),
  reasonBreakdown: z.array(reasonBreakdownSchema).nullish(),
});

export type DashboardStats = z.infer<typeof dashboardStatsSchema>;
